import AvantiKeyIcon from './AvantiKeyIcon';

export default AvantiKeyIcon;
